import * as THREE from 'three';

/**
 * Confetti particle system for wave completion celebration
 */
export class ConfettiSystem {
    constructor(scene) {
        this.scene = scene;
        this.particles = [];
        this.isActive = false;
    }
    
    /**
     * Create confetti explosion
     * @param {THREE.Vector3} position - Center position for confetti
     * @param {number} count - Number of confetti particles
     */
    createConfetti(position, count = 100) {
        this.isActive = true;
        this.particles = [];
        
        const colors = [
            0xff0000, // Red
            0x00ff00, // Green
            0x0000ff, // Blue
            0xffff00, // Yellow
            0xff00ff, // Magenta
            0x00ffff, // Cyan
            0xff8800, // Orange
            0x8800ff  // Purple
        ];
        
        for (let i = 0; i < count; i++) {
            const color = colors[Math.floor(Math.random() * colors.length)];
            const size = Math.random() * 0.2 + 0.1;
            
            const geometry = new THREE.BoxGeometry(size, size, size);
            const material = new THREE.MeshStandardMaterial({
                color: color,
                emissive: color,
                emissiveIntensity: 0.5
            });
            
            const particle = new THREE.Mesh(geometry, material);
            
            // Random starting position around center
            const angle = Math.random() * Math.PI * 2;
            const radius = Math.random() * 2;
            particle.position.set(
                position.x + Math.cos(angle) * radius,
                position.y + Math.random() * 3,
                position.z + Math.sin(angle) * radius
            );
            
            // Random velocity
            particle.userData.velocity = new THREE.Vector3(
                (Math.random() - 0.5) * 10,
                Math.random() * 8 + 5,
                (Math.random() - 0.5) * 10
            );
            
            // Random rotation
            particle.userData.rotation = new THREE.Vector3(
                (Math.random() - 0.5) * 0.2,
                (Math.random() - 0.5) * 0.2,
                (Math.random() - 0.5) * 0.2
            );
            
            particle.userData.gravity = -9.82;
            particle.userData.lifetime = 3.0; // 3 seconds
            particle.userData.age = 0;
            
            this.scene.add(particle);
            this.particles.push(particle);
        }
    }
    
    /**
     * Update confetti particles
     * @param {number} deltaTime - Time since last frame
     */
    update(deltaTime) {
        if (!this.isActive) return;
        
        for (let i = this.particles.length - 1; i >= 0; i--) {
            const particle = this.particles[i];
            
            // Update position
            particle.position.add(
                particle.userData.velocity.clone().multiplyScalar(deltaTime)
            );
            
            // Apply gravity
            particle.userData.velocity.y += particle.userData.gravity * deltaTime;
            
            // Update rotation
            particle.rotation.x += particle.userData.rotation.x;
            particle.rotation.y += particle.userData.rotation.y;
            particle.rotation.z += particle.userData.rotation.z;
            
            // Update age
            particle.userData.age += deltaTime;
            
            // Fade out
            const lifeRatio = 1 - (particle.userData.age / particle.userData.lifetime);
            particle.material.opacity = Math.max(0, lifeRatio);
            particle.material.transparent = true;
            
            // Remove if dead
            if (particle.userData.age >= particle.userData.lifetime) {
                this.scene.remove(particle);
                particle.geometry.dispose();
                particle.material.dispose();
                this.particles.splice(i, 1);
            }
        }
        
        // Deactivate if no particles left
        if (this.particles.length === 0) {
            this.isActive = false;
        }
    }
    
    /**
     * Cleanup
     */
    destroy() {
        this.particles.forEach(particle => {
            this.scene.remove(particle);
            particle.geometry.dispose();
            particle.material.dispose();
        });
        this.particles = [];
        this.isActive = false;
    }
}


